import React, { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

export default function CurrencyInput({ value, onChange, ...props }) {
  const formatDisplay = (v) => {
    if (!v && v !== 0) return "";
    const num = typeof v === "string" ? parseFloat(v) : v;
    if (isNaN(num)) return "";
    return num.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const parseValue = (display) => {
    const cleaned = display.replace(/\./g, "").replace(",", ".");
    const num = parseFloat(cleaned);
    return isNaN(num) ? "" : String(num);
  };

  const inputRef = React.useRef(null);
  const [display, setDisplay] = useState(formatDisplay(value));

  useEffect(() => {
    if (document.activeElement !== inputRef.current) {
      setDisplay(formatDisplay(value));
    }
  }, [value]);

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">R$</span>
      <Input ref={inputRef} {...props} type="text" inputMode="decimal" value={display}
        onChange={(e) => {
          const raw = e.target.value.replace(/[^\d.,]/g, "");
          setDisplay(raw);
        }}
        onBlur={(e) => {
          const parsed = parseValue(e.target.value);
          onChange(parsed);
          setDisplay(formatDisplay(parsed));
        }}
        className={`${props.className || ""} pl-9`} />
    </div>
  );
}
